module.exports = __webpack_public_path__ + "static/img/photo12.93e76295.jpg";